<template>
  <div class="container">
    <a-breadcrumb separator=">">
      <a-breadcrumb-item href="" @click.native="() => $router.push('/')"
        >首页</a-breadcrumb-item
      >
      <a-breadcrumb-item href="" @click.native="() => $router.back()"
        >上一页</a-breadcrumb-item
      >
      <a-breadcrumb-item>检验检查报告</a-breadcrumb-item>
    </a-breadcrumb>

    <!--就诊人-->
    <a-card title="就诊人" style="margin-top: 20px">
      <template v-if="patientInfo.name">
        <i slot="extra" class="switch" @click="switchPatient">切换</i>
        <div class="list-pro-name">
          <div class="item-name">
            <span class="item-name-text">{{ patientInfo.name }}</span>
          </div>
          <div class="item-department-name">
            证件号：{{ patientInfo.idNumber }}
          </div>
          <div class="item-department-name">
            手机号：{{ patientInfo.phone }}
          </div>
        </div>
      </template>

      <div class="no" v-else-if="isNoPatient">
        <a-result status="warning" title="请先添加就诊人">
          <template #extra>
            <a-button key="console" type="primary" @click="addPatient">
              添加
            </a-button>
          </template>
        </a-result>
      </div>
    </a-card>

    <a-tabs :default-active-key="source" @change="tabChange">
      <a-tab-pane
        :key="item.key"
        :tab="item.name"
        v-for="item in tabs"
        :disabled="loading"
      >
      </a-tab-pane>
    </a-tabs>

    <a-alert
      v-if="source == 21 || source == 22 || source == 23"
      style="margin-bottom: 10px"
      message="温馨提示：手工录入的条码无法查询到数据"
      banner
    />

    <!--类型-->
    <a-radio-group v-model="type" @change="onChange" :disabled="loading">
      <a-radio :value="1"> 检验报告 </a-radio>
      <a-radio :value="2"> 检查报告 </a-radio>
    </a-radio-group>

    <!--新-->
    <div class="tab-content">
      <!--左侧滚动栏-->
      <aside class="scroll">
        <a-list :data-source="list" size="large">
          <a-list-item
            slot="renderItem"
            slot-scope="item, index"
            class="data-list"
            :class="[activedIndex == index ? 'actived' : '']"
          >
            <a-list-item-meta
              :description="item.checkTime"
              v-if="type == 1 && source != 3 && source != 23"
              @click="onDetail(item, index)"
            >
              <a slot="title">{{ item.sheetName }}</a>
              <a-avatar slot="avatar" :src="avatarSrc" />
            </a-list-item-meta>

            <a-list-item-meta
              :description="item.resultTime"
              v-else-if="type == 1 && (source == 3 || source == 23)"
              @click="onDetail(item, index)"
            >
              <a slot="title">{{ item.deptName }} </a>
              <a-avatar slot="avatar" :src="avatarSrc" />
            </a-list-item-meta>

            <a-list-item-meta
              :description="item.reportDate"
              v-else-if="type == 2"
              @click="onDetail2(item, index)"
            >
              <a slot="title">{{ item.patName }} {{ item.type }}</a>
              <a-avatar slot="avatar" :src="avatarSrc" />
            </a-list-item-meta>
          </a-list-item>
          <!--加载更多-->
          <div
            v-if="showLoadingMore"
            slot="loadMore"
            :style="{
              textAlign: 'center',
              marginTop: '12px',
              height: '32px',
              lineHeight: '32px',
            }"
          >
            <a-spin v-if="loadingMore" />
            <a-button v-else @click="onLoadMore">下一页</a-button>
          </div>
        </a-list>
        <a-spin tip="加载中..." v-if="loading"> </a-spin>
      </aside>

      <!--左侧滚动栏-->

      <!--内容-->
      <main>
        <!--门诊、住院检验内容-->
        <template v-if="type == 1 && source != 3 && source != 23">
          <div class="detail" v-if="detail && detail.sheetName">
            <p>报告单项目名：{{ detail.sheetName }}</p>
            <p>姓名：{{ detail.patName }}</p>
            <p>病案号：{{ detail.patCardNo }}</p>
            <p>条号码：{{ detail.barCode }}</p>
            <p>报告单ID：{{ detail.sheetId }}</p>
            <p>性别：{{ detail.gender }}</p>
            <p>科别：{{ detail.labDepartment }}</p>
            <p>标本种类：{{ detail.sampleType }}</p>
            <p v-if="(source == 21 || source == 22) && type == 1">年龄：{{ detail.ageNL }}</p>
            <p v-else>年龄：{{ detail.age }}</p>
            <p>状态：{{ detail.resultStatus }}</p>
            <p>检验目的：{{ detail.checkPurpose }}</p>

            检验结果：
            <div
              v-for="(item, index) in detail.itemList"
              :key="index"
              class="item-type"
            >
              <a-descriptions>
                <a-descriptions-item label="项目名称">
                  {{ item.itemName }} {{ item.status }}
                </a-descriptions-item>
                <a-descriptions-item label="结果">
                  {{ item.value }}
                </a-descriptions-item>
                <a-descriptions-item label="参考范围">
                  {{ item.valueRange }}
                </a-descriptions-item>
                <a-descriptions-item label="单位">
                  {{ item.unit }}
                </a-descriptions-item>
              </a-descriptions>
            </div>
            <p>送检医生：{{ detail.requester }}</p>
            <p>检验者：{{ detail.executor }}</p>
            <p>审核者：{{ detail.checkOperator }}</p>
            <p>采集时间：{{ detail.executeTime }}</p>
            <p>接收时间：{{ detail.receiveTime }}</p>
            <p>报告时间：{{ detail.checkTime }}</p>
            <a class="down" target="_blank" @click="onDown()">下载报告</a>
          </div>
          <div class="detail" v-else>
            <a-empty />
          </div>
        </template>
        <!--体检检验内容-->
        <template v-if="type == 1 && (source == 3 || source == 23)">
          <div class="detail" v-if="detail && detail.departmentName">
            <p>报告单项目名：{{ detail.departmentName }}</p>
            <p>小结：{{ detail.summary }}</p>
            <p>检验者：{{ detail.checker }}</p>
            <p>报告时间：{{ detail.checkDate }}</p>
            检验结果：
            <div
              v-for="(item, index) in detail.itemList"
              :key="index"
              class="item-type"
            >
              <a-descriptions>
                <a-descriptions-item label="项目名称">
                  {{ item.itemName }}
                </a-descriptions-item>
                <a-descriptions-item label="结果">
                  {{ item.result }}
                </a-descriptions-item>
                <a-descriptions-item label="参考范围">
                  {{ item.referenceRange }}
                </a-descriptions-item>
                <a-descriptions-item label="单位">
                  {{ item.unit }}
                </a-descriptions-item>
              </a-descriptions>
            </div>

            <a class="down" target="_blank" @click="onDown()">下载报告</a>
          </div>
          <div class="detail" v-else>
            <a-empty />
          </div>
        </template>
        <!--检查内容-->
        <template v-else-if="type == 2">
          <!-- <div class="detail" v-if="url">
            <div class="img-show">
              <img :src="url" :preview="url" :alt="url" />
            </div>
          </div>
          <div class="detail" v-else-if="isNo">
            <a-empty />
          </div> -->
        </template>
      </main>

      <!--内容-->
    </div>

    <!--新-->
    <!--就诊人弹窗-->
    <patientList
      ref="patientRef"
      :isCreate="isCreate"
      @changePatient="changePatient"
    >
    </patientList>
  </div>
</template>

<script>
import {
  getJyReportList,
  getJyReportList2,
  getJcReportList,
  getJcReportList2,
  getJyReportDetail,
  getJcReportDetail,
  getJyReportDetail2,
  getJcReportDetail2,
  getPJyReportList,
  getPJyReportList2,
  getPJyReportDetails,
  getPJyReportDetails2,
  getPJcReportList,
  getPJcReportList2,
  getJcReportDetail3,
} from "@/api/report";
import { getListPatients } from "@/api/bac";

import md5 from "@/utils/md5";

//头像
import avatarSrc from "@/assets/img/icon_6.png";
import patientList from "@/components/patientList";
export default {
  data() {
    return {
      isCreate: false,
      showLoadingMore: false,
      source: 1,
      patientInfo: {},
      isNoPatient: false,
      url: "",
      avatarSrc,
      activedIndex: null,
      type: 1,
      list: [],
      loading: false,
      busy: false,
      detail: "",
      isNo: false,
      tabs: [
        { key: 1, name: "门诊" },
        { key: 21, name: "门诊-新版" },
        { key: 2, name: "住院" },
        { key: 22, name: "住院-新版" },
        { key: 3, name: "体检" },
        { key: 23, name: "体检-新版" },
      ],
      src: "",
      page: 1,
      pageNum: 1,
      pageSize: 10,
    };
  },
  created() {
    this.userInfo =
      sessionStorage.getItem("userInfo") &&
      JSON.parse(sessionStorage.getItem("userInfo"));

    this.listPatients();
    this.list = [];
    //弹窗
    this.$info({
      title: "提示",
      content: "在2025年3月1日前选择旧版，之后选择新版",
      onOk() {},
    });
  },
  mounted() {},
  methods: {
    onLoadMore() {
      this.pageNum++;
      this.loadingMore = true;
      this.loading = true;
      this.showLoadingMore = false;
      if (this.type == 2) {
        this.getList2();
      } else {
        this.getList();
      }
    },
    //切换就诊人
    switchPatient() {
      this.$refs.patientRef.getList();
    },
    addPatient() {
      this.$router.push({
        path: "/myRegistration",
        query: {
          queryActived: 7,
        },
      });
    },
    //就诊人列表
    async listPatients() {
      const params = {
        userNo: this.userInfo.userNo,
      };
      const { code, data, total } = await getListPatients(params);
      if (code == 200) {
        if (data && data.length > 0) {
          this.patientInfo = data[0];
          this.isNoPatient = false;
          this.onSearch();
        } else {
          this.isNoPatient = true;
        }
      }
    },
    /**切换就诊人 */
    changePatient(item) {
      this.patientInfo = item;
      this.onSearch();
    },
    onDown() {
      let path = location.origin + location.pathname;
      let v = this.source > 3 ? 2 : 1;
      sessionStorage.setItem("v", v);
      if (this.source == 3 || this.source == 23) {
        sessionStorage.setItem("i", this.physicalExamNo);
        sessionStorage.setItem("deptName", this.deptName);
        location.href =
          path + "physicalExaminationSheet.html?t=" + new Date().getTime();
      } else {
        sessionStorage.setItem("i", this.sheetId);
        location.href =
          path + "inspection-report.html?t=" + new Date().getTime();
      }
    },
    //切换tab
    tabChange(key) {
      this.source = key;
      this.url = "";
      this.onSearch();
    },
    onSearch() {
      this.pageNum = 1;
      this.list = [];
      this.detail = {};
      this.activedIndex = null;
      this.loading = true;
      this.showLoadingMore = false;
      if (this.type == 2) {
        this.getList2();
      } else {
        this.getList();
      }
    },
    //修改类型
    onChange(e) {
      this.onSearch();
    },

    onDetail(data, activedIndex) {
      this.activedIndex = activedIndex;
      this.sheetId = data.sheetId;
      this.physicalExamNo = data.physicalExamNo;
      this.deptName = data.deptName;
      this.getJyDetail(data);
    },
    onDetail2(data, activedIndex) {
      this.activedIndex = activedIndex;
      this.getJcDetail(data.applicationNumber, activedIndex);
    },
    //检验列表
    async getList() {
      let source = this.source;
      if (this.source == 21) {
        source = 1;
      } else if (this.source == 22) {
        source = 2;
      } else if (this.source == 23) {
        source = 3;
      }

      const params = {
        source,
        idCardNo: this.patientInfo.idNumber, //证件号
        timeRange: 3, //时间段 1->一年内 3->三年内 若此处不为空则以当前时间计算时间范围，为空则以'startDate'和'endDate'字段为时间范围
        pageNum: this.pageNum, //页码 默认为1
        pageSize: this.pageSize, //每页记录数 默认为10
      };
      const { data, code } =
        source == 3
          ? this.source <= 3
            ? await getPJyReportList({
                idCardNo: this.patientInfo.idNumber, //证件号
                timeRange: 3,
                reportType: 2,
              })
            : await getPJyReportList2({
                idCardNo: this.patientInfo.idNumber, //证件号
                timeRange: 3,
                reportType: 2,
              })
          : this.source <= 3
          ? await getJyReportList(params)
          : await getJyReportList2(params);

      this.loading = false;
      this.loadingMore = false;
      if (code == 200) {
        if (this.source == 3 || this.source == 23) {
          this.list = data;
          if (data.length <= 0) {
            this.busy = true;
            this.loading = false;
          }
        } else {
          this.list.push(...data);
          this.showLoadingMore = true;
          if (data.length <= 0) {
            this.busy = true;
            this.loading = false;

            this.showLoadingMore = false;
          }
        }
      } else {
        this.isNo = true;
        this.list = [];
        this.showLoadingMore = false;
      }
    },
    //检查列表
    async getList2() {
      let source = this.source;
      if (this.source == 21) {
        source = 1;
      } else if (this.source == 22) {
        source = 2;
      } else if (this.source == 23) {
        source = 3;
      }

      const params = {
        source,
        timeRange: "3",
        idCardNo: this.patientInfo.idNumber, //证件号
        pageNum: this.pageNum, //页码 默认为1
        pageSize: this.pageSize, //每页记录数 默认为10
      };

      const { data, code } =
        source == 3
          ? this.source <= 3
            ? await getPJcReportList({
                ...params,
                reportType: 3,
              })
            : await getPJcReportList2({
                ...params,
                reportType: 1,
              })
          : this.source <= 3
          ? await getJcReportList(params)
          : await getJcReportList2(params);

      this.loading = false;
      this.loadingMore = false;

      if (code == 200) {
        this.list.push(...data);
        this.showLoadingMore = true;
        if (data.length <= 0) {
          this.busy = true;
          this.loading = false;
          this.showLoadingMore = false;
        }

        if (this.list.length <= 0) {
          this.isNo = true;
        } else {
          this.isNo = false;
        }
      } else {
        this.isNo = true;
        this.list = [];
        this.showLoadingMore = false;
      }
    },

    //检查报告请求
    async getJcDetail(applicationNumber, i) {
      this.isNo = false;
      let sign = md5(applicationNumber + "ZheDa@SIGN");
      const { data, code } =
        this.source > 3
          ? this.source == 23
            ? await getJcReportDetail2(applicationNumber, sign)
            : await getJcReportDetail3(applicationNumber, sign)
          : await getJcReportDetail(applicationNumber, sign);
      if (code == 200) {
        if (data && data.length > 0) {
          //云影像链接
          let url = data[0].pacsUrl;
          if (this.source > 3) {
            //新版
            if (
                data[0].type.toUpperCase() == "US" ||
                data[0].type.toUpperCase() == "ECG" ||
                data[0].type.toUpperCase() == "ES" ||
                data[0].type.toUpperCase() == "BC" ||
                data[0].type.toUpperCase() == "XDT"
              ) {
                url = data[0].url;
              };
              
          } else {
            //旧版
            if (this.source != 3) {
              if (
                data[0].type.toUpperCase() == "US" ||
                data[0].type.toUpperCase() == "ECG" ||
                data[0].type.toUpperCase() == "ES" 
              ) {
                url = data[0].url;
              }
            }
          }

          window.open(url);
          this.isNo = false;
        } else {
          this.isNo = true;
        }
      } else {
        this.isNo = true;
      }
    },
    //检验报告详情
    async getJyDetail(item) {
      let source = this.source;
      if (this.source == 21) {
        source = 1;
      } else if (this.source == 22) {
        source = 2;
      } else if (this.source == 23) {
        source = 3;
      }

      const { data, code } =
        source == 3
          ? this.source <= 3
            ? await getPJyReportDetails(item)
            : await getPJyReportDetails2(item)
          : this.source <= 3
          ? await getJyReportDetail(item.sheetId)
          : await getJyReportDetail2(item.sheetId);

      if (code == 200) {
        this.detail = data;
      }
    },
  },
  components: {
    patientList,
  },
};
</script>

<style lang="scss" scoped>
.down {
  position: absolute;
  top: 10px;
  right: 20px;
}

.item-type {
  margin-top: 10px;
  padding-right: 20px;
}

.container {
  .tab-content {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    padding: 0 20px;

    .list,
    .detail,
    .detail1 {
      position: relative;
      border: 1px solid #e8e8e8;
      padding: 16px;
    }

    .scroll {
      height: 500px;
      min-width: 325px;
      flex: 1;
      overflow-y: scroll;
      overflow-x: hidden;
      text-align: center;
      border: 1px solid #e8e8e8;
      .list {
        background: inherit;
        background-color: #ffffff;

        .list-item {
          display: flex;
          margin-bottom: 16px;
          padding: 10px;
          border-bottom: 1px solid #e8e8e8;
          align-items: center;
          cursor: pointer;

          img {
            width: 40px;
            height: 40px;
            margin: 10px 10px 0 0;
          }

          .list-pro-name {
            .item-name,
            .item-time {
              margin: 4px 0;
              color: #999;
            }

            .item-name {
              font-size: 16px;
              color: #333;
              font-weight: bold;
            }
          }
        }
      }
    }
    .detail {
      flex: 2;
      min-width: 600px;
      height: 500px;
      overflow-y: scroll;
      background: inherit;
      background-color: rgba(255, 255, 255, 1);
    }

    .detail1 {
      width: 100%;
      background-color: rgba(255, 255, 255, 1);
    }
  }
}

/deep/.ant-tabs-tab {
  font-size: 20px;
}

.actived {
  background-color: rgba($color: #3e83f9, $alpha: 0.1);
  border-bottom: 1px solid #3e83f9 !important;
}
.img-show {
  text-align: center;
  width: 100%;
  cursor: pointer;
  overflow-x: auto;
  img {
    display: block;
    height: 800px;
  }
}

.demo-infinite-container {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  overflow: auto;
  padding: 8px 24px;
  height: 300px;
}
.demo-loading-container {
  position: absolute;
  bottom: 40px;
  width: 100%;
  text-align: center;
}
.data-list {
  padding: 10px;
  text-align: left;
  cursor: pointer;
}
.doctor {
  margin-top: 20px;
  box-sizing: border-box;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  padding: 30px;
  cursor: pointer;
  .img {
    width: 60px;
    height: 60px;
    margin-right: 12px;
    img {
      height: 100%;
      width: 100%;
      border-radius: 50%;
    }
  }

  .list-pro-name {
    flex: 1;
    .item-name {
      margin: 2px 0;
    }

    .item-name {
      font-size: 14px;

      &-text {
        font-size: 20px;
        color: #333;
      }

      &-job {
        color: #333;
        padding: 0 10px;
      }
    }

    .item-department-name {
      margin-top: 4px;
      color: #666;
    }

    .about,
    .skilled {
      margin-top: 20px;

      p {
        color: #8e8e8e;
        padding-left: 6px;
      }
    }
  }
}
.switch {
  cursor: pointer;
  color: #1890ff;
}
</style>
